var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[`category-sidebar${_vm.isSidebarOpen ? ' visible' : ' hidden'}`]},[_c('HeadlineBlocks',{key:`category-${_vm.activeArticleCategoryId}`,attrs:{"data":{ items: _vm.headlines },"settings":{ ..._vm.settings },"block-type":"BlockType4"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }